// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7184c3a4","382":"cfea3e80","446":"b447c69e","455":"cedcf307","755":"a7f45a9d"}[chunkId] + ".chunk.js";
};